export default __webpack_public_path__ + "static/media/episode-12.63600da8.webp";